import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as IBooks from '../../../../../interfaces/merchants/resources/books';
import * as IInputs from '../../../../../interfaces/merchants/resources/books/inputs';

import BooksErrorMessage from './components/BooksErrorMessage';

import css from './InputCompletionFailed.module.scss';
import { useScrollToTop } from '../../../../../hooks/useScrollToTop';
import { RSButton } from 'src/reservation-page/RSButton';

interface ElementProps {
  settings: IBooks.SettingCompletion;
  backToLabel: string;
  backToModifyPage: () => void;
}

interface StateProps {
  inputs: IInputs.State;
}

type Props = ElementProps & StateProps;

const DetailErrorMessage = ({ message }: { message: string }) => {
  return (
    <div className={css.InputCompletionFailed__DetailErrorMessage}>
      {message}
    </div>
  );
};

const InputCompletionFailed: FC<Props> = (props: Props) => {
  useScrollToTop();
  const { settings, backToLabel, backToModifyPage } = props;
  const intl = useIntl();

  return (
    <div className={css.InputCompletionFailed}>
      {settings.entireError && (
        <BooksErrorMessage
          errorType={settings.entireError}
          className={css.InputCompletionFailed__ErrorMessage}
        />
      )}

      {settings.errorDetail && (
        <DetailErrorMessage message={settings.errorDetail.message} />
      )}
      <div className="px-[18px] py-5">
        <RSButton
          variant="basic"
          isBlock
          value={intl.formatMessage({
            id: backToLabel,
          })}
          onClick={backToModifyPage}
        >
          {intl.formatMessage({
            id: backToLabel,
          })}
        </RSButton>
      </div>
    </div>
  );
};

const mapStateProps = ({
  merchantsResourcesBooksInputs,
}: {
  merchantsResourcesBooksInputs: IInputs.State;
}): StateProps => ({
  inputs: merchantsResourcesBooksInputs,
});

export default connect(mapStateProps)(InputCompletionFailed);
